import { MjmlColumn, MjmlSection, MjmlText } from "@faire/mjml-react";
import {
  Section,
  SharedProps,
  TemplateType,
} from "@redotech/redo-model/email-builder";
import { memo } from "react";

export type FooterState = Section.Footer & SharedProps;

export const EmailFooter = memo(function emailFooter(props: FooterState) {
  if (!props.schemaFieldName) throw new Error("schemaFieldName is required");

  const padding = props.sectionPadding;

  const unsubscribeLink = props.schemaInstance[props.schemaFieldName];
  const address = props.template.address;

  if (unsubscribeLink && typeof unsubscribeLink !== "string") {
    throw new Error("Footer render error: Unsubscribe link must be a string");
  }

  return (
    <MjmlSection
      backgroundColor={props.sectionColor || "#ffffff"}
      paddingBottom={padding.bottom}
      paddingLeft={padding.left}
      paddingRight={padding.right}
      paddingTop={padding.top}
      textAlign={props.alignment || "center"}
    >
      <MjmlColumn>
        <MjmlText
          align={props.alignment || "center"}
          color={props.textColor || "#000000"}
          fontFamily={props.fontFamily}
          fontSize={props.fontSize}
          lineHeight="1.5"
        >
          {address.businessAddress && address.businessAddress + ", "}
          {address.legalAddress}
          <br />
          {address.cityStateZip}
          <br />
          {address.country}

          {/*
        If unsubscribeLink is ever null for marketing emails, that is illegal.
        Wherever emails get rendered, make sure they avoid this possibility.
      */}
          {(props.template.templateType === TemplateType.MARKETING ||
            props.template.category === "Marketing") &&
            unsubscribeLink && (
              <div
                style={{
                  margin: `15px 0px 0px 0px`,
                  color: props.template.linkColor || "#0000ee",
                }}
              >
                <u>
                  <a
                    href={unsubscribeLink.toString()}
                    style={{ color: "inherit" }}
                  >
                    Unsubscribe
                  </a>
                </u>
              </div>
            )}
        </MjmlText>
      </MjmlColumn>
    </MjmlSection>
  );
});
